// @ts-strict-ignore
import {Component, input} from "@angular/core";
import {ExamPhase, SessionPhaseType} from "@models";
import {Translations} from "@translations";
import {TypePredicates} from "@services";
import {PhaseColorMapping} from "../../models/SimSessionPhasePalette";
import {AudioElementComponent} from "@common/ui/audio-element/audio-element.component";

@Component({
	selector: "sim-phase-nav-button",
	templateUrl: "./phase-nav-button.component.html",
	styleUrl: "./phase-nav-button.component.scss",
	standalone: false,
})
export class PhaseNavButtonComponent {
	// I/O
	public readonly phase = input.required<ExamPhase>();
	public readonly audioElement = input.required<AudioElementComponent>();

	// Readonly
	protected readonly T = Translations;
	protected readonly SessionPhaseType = SessionPhaseType;
	protected readonly TypePredicates = TypePredicates;
	protected readonly PhaseColorMapping = PhaseColorMapping;

	protected getPhaseNameLocalizationKey(): string {
		const nameToken = `EXAM_PHASE_${SessionPhaseType[this.phase().type]}`;
		return this.T[nameToken];
	}

	protected getClinicalVignetteDuration(): number {
		const phase = this.phase();
		if (TypePredicates.isExamPhaseEncounter(phase)) {
			return phase.clinicalVignetteDurationInSeconds * 1000;
		}
	}
}
